<script>
	import { pageOffset, isPortraitScreen } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';
	import { onMount } from 'svelte';

	let _bushes;
	let portrait;

	let animation = (value) => {
		animateElement(value, _bushes, (currentPageOffset) => {
			_bushes.style.transform = `translateY(calc(50% - ${currentPageOffset * 0.003}em))`;
		});
	};

	let prepareScene = () => {
		if (!_bushes) {
			requestAnimationFrame(prepareScene);
			return;
		}

		pageOffset.subscribe(animation);
	};

	onMount(() => {
		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
		prepareScene();
	});

</script>

<style>
	.bushes {
		position: absolute;
		left: 0;
		bottom: 3em;
		width: 100%;
		z-index: 5;
	}

	.bushes.portrait {
		bottom: 1em;
	}

	svg {
		width: 110vw;
		margin-left: -5vw;
		height: auto;
		float: left;
	}

	svg:last-of-type {
		/*calc aspect ratio of lowest svg-polygon*/
		margin-top: calc((215.1 / 1440) * -110vw);
	}

	.portrait svg:last-of-type {
		margin-top: calc((215.1 / 1440) * -10vw);
	}
</style>

<div class:portrait class="bushes" id="bushes" bind:this={_bushes}>
	<div>
		<svg width="1440" height="441" viewBox="0 0 1440 441" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1440 441V99.5C1435.8 99.1 1431.6 98.8 1427.3 98.8C1396.9 98.8 1369 110.2 1347.7 129C1323.3 115.9 1295.4 108.4 1265.9 108.4C1195.7 108.4 1134.9 150.5 1107.5 210.7C1088.7 206.2 1069 203.8 1048.8 203.8C1032.1 203.8 1015.9 205.5 1000.1 208.6C978 180.1 943.4 161.8 904.8 161.8C861.6 161.8 823.5 184.8 802.2 219.1C781 212.2 758.3 208.5 734.7 208.5C707.6 208.5 681.5 213.5 657.5 222.7C642.6 206.3 621.1 196 597.3 196C572 196 549.3 207.7 534.4 225.9C504.2 200.8 465.4 185.6 423.2 185C409.6 185 396.4 186.6 383.8 189.5C353.6 139.7 299 106.5 236.3 105.6C233.4 105.6 230.6 105.7 227.7 105.8C195.2 43.5 130.3 1.1 55 0C35.9 0 17.5 2.8 0 7.9V441H1440Z" fill="#008B60"/>
		</svg>
		<svg width="1440" height="287" viewBox="0 0 1440 287" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M0 0V248.9C72.2 261.6 255.3 286.9 412.8 286.9C609.8 286.9 870.8 215.9 1100.8 215.9C1234.8 215.9 1345.3 234.6 1440 247.8V0H0Z" fill="#008B60"/>
		</svg>
	</div>
	<slot/>
</div>
